export class TimeEntryGridConfigModel {
    id = 0;
    User: number = null;
    Configuration = '';
}
